import type { FrMrgaPolicyItem, FrMrgaPolicyItemScope } from '../fr-mrga-insurance.ts'

const CONTRACT = { type: 'contract' } as const

const ALL_BUT_FOR_SALE = {
  executive: true,
  company: true,
  tow_truck: true,
  two_wheeler: true,
  rental: true,
  for_sale: false,
  light_trailer: true,
} as const

const FOR_SALE_ONLY = {
  executive: false,
  company: false,
  tow_truck: false,
  two_wheeler: false,
  rental: false,
  for_sale: true,
  light_trailer: false,
} as const

// A third-party vehicle is insured for its liability alone, so it carries no damage guarantee.
const DAMAGE_FORMULAS = { third_party: false, third_party_plus: true, all_risks: true } as const

export const frMrgaScopeByPolicyItem_v1_0_0 = {
  publicLiability: CONTRACT,
  productsAndCompletedWorksLiability: CONTRACT,
  fire: CONTRACT,
  electricalDamage: CONTRACT,
  climateEvents: CONTRACT,
  naturalDisasters: CONTRACT,
  terrorism: CONTRACT,
  waterDamage: CONTRACT,
  buildingDamageAfterTheft: CONTRACT,
  theft: CONTRACT,
  glass: CONTRACT,
  machineryAndComputerBreakage: CONTRACT,
  businessInterruption: CONTRACT,
  civilLiability: CONTRACT,
  criminalDefenseAndRecourse: CONTRACT,
  driverProtection: CONTRACT,
  ownedVehiclesDamage: { type: 'vehicle', uses: ALL_BUT_FOR_SALE, formulas: DAMAGE_FORMULAS },
  personalBelongingsAndAccessories: CONTRACT,
  vehiclesForSaleDamage: { type: 'vehicle', uses: FOR_SALE_ONLY, formulas: DAMAGE_FORMULAS },
  entrustedVehiclesDamage: CONTRACT,
  legalProtection: CONTRACT,
  assistance: CONTRACT,
} as const satisfies Record<FrMrgaPolicyItem, FrMrgaPolicyItemScope>
